module.exports = __webpack_public_path__ + "img/hc-icon01.9eb835a1.svg";